import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { polyfill } from 'react-lifecycles-compat';
import classnames from 'classnames';
import CONST from './const';
import DateCell from './DateCell';
import Icon from '../Icon';

var DatePanel = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePanel, _React$Component);

  var _super = _createSuper(DatePanel);

  function DatePanel() {
    var _this;

    _classCallCheck(this, DatePanel);

    _this = _super.apply(this, arguments);
    _this.state = {
      startDate: _this.props.startDate,
      selectDate: _this.props.selectDate
    };

    _this.selectDate = function (timestamp, evt) {
      evt.stopPropagation();

      _this.props.onSelectDate(timestamp, evt);
    };

    _this.preYear = function () {
      _this.props.handleChangeDate('subtract', 'year');
    };

    _this.preMonth = function () {
      _this.props.handleChangeDate('subtract', 'month');
    };

    _this.nextMonth = function () {
      _this.props.handleChangeDate('add', 'month');
    };

    _this.nextYear = function () {
      _this.props.handleChangeDate('add', 'year');
    };

    _this.showMonth = function () {
      _this.props.onShowPanel('month');
    };

    _this.showYear = function () {
      _this.props.onShowPanel('year');
    };

    return _this;
  }

  _createClass(DatePanel, [{
    key: "renderDatePanel",
    value: function renderDatePanel() {
      var _this2 = this;

      var today = dayjs();
      var _this$state = this.state,
          selectDate = _this$state.selectDate,
          startDate = _this$state.startDate;
      var _this$props = this.props,
          onHover = _this$props.onHover,
          hoverDate = _this$props.hoverDate,
          disabledDate = _this$props.disabledDate,
          type = _this$props.type,
          dateCellRender = _this$props.dateCellRender;
      var nextMonth = startDate.add(1, 'month');
      nextMonth = nextMonth.set('date', 14).set('hour', 0).set('minute', 0).set('second', 0);
      var pointerDate = startDate.set('date', 1);

      if (pointerDate.day() === 0) {
        // 如果月初1号是周日
        pointerDate = pointerDate.subtract(1, 'day');
      }

      while (pointerDate.day() >= 1) {
        pointerDate = pointerDate.subtract(1, 'day');
      }

      var html = [];
      var tdArr = [];
      var maxSelectDate = dayjs();

      if (selectDate[1]) {
        var _selectDate = _slicedToArray(selectDate, 2);

        maxSelectDate = _selectDate[1];
      } else {
        var _selectDate2 = _slicedToArray(selectDate, 1);

        maxSelectDate = _selectDate2[0];
      }

      while (pointerDate.valueOf() < nextMonth.valueOf()) {
        tdArr = CONST.DAYS.map(function () {
          pointerDate = pointerDate.add(1, 'day');
          var inRange = hoverDate && (selectDate[0] && pointerDate.valueOf() > selectDate[0].valueOf() && pointerDate.valueOf() < hoverDate.valueOf() || maxSelectDate && pointerDate.valueOf() > hoverDate.valueOf() && pointerDate.valueOf() < maxSelectDate.valueOf()) || maxSelectDate && selectDate[0] && pointerDate.valueOf() > selectDate[0].valueOf() && pointerDate.valueOf() < maxSelectDate.valueOf();
          var disabled = disabledDate && disabledDate(pointerDate);

          if (pointerDate.year() === (startDate && startDate.year()) && pointerDate.month() === (startDate && startDate.month())) {
            var dayClass = classnames({
              old: pointerDate.format('YYYYMM') !== (startDate && startDate.format('YYYYMM')),
              day: pointerDate.valueOf() > today.valueOf(),
              'day today': pointerDate.format('YYYYMMDD') === today.format('YYYYMMDD'),
              active: pointerDate.format('YYYYMMDD') === (selectDate[0] && selectDate[0].format('YYYYMMDD')) || selectDate[1] && pointerDate.format('YYYYMMDD') === selectDate[1].format('YYYYMMDD') || hoverDate && pointerDate.format('YYYYMMDD') === hoverDate.format('YYYYMMDD'),
              disabled: disabled,
              'in-range': inRange
            });
            return /*#__PURE__*/React.createElement(DateCell, {
              key: "".concat(pointerDate.date()).concat(pointerDate.month()).concat(pointerDate.year()),
              className: dayClass,
              date: pointerDate,
              onSelectDate: _this2.selectDate,
              disabled: disabled,
              onHover: onHover,
              dateText: pointerDate.date(),
              dateCellRender: dateCellRender
            });
          } else {
            var className = disabled ? 'day old disabled' : 'day old';

            if (type === 'week') {
              className = classnames({
                day: true,
                old: true,
                'in-range': inRange,
                active: pointerDate.format('YYYYMMDD') === (selectDate[0] && selectDate[0].format('YYYYMMDD')) || selectDate[1] && pointerDate.format('YYYYMMDD') === selectDate[1].format('YYYYMMDD')
              });
            }

            return /*#__PURE__*/React.createElement(DateCell, {
              key: "".concat(pointerDate.date()).concat(pointerDate.month()).concat(pointerDate.year()),
              className: className,
              date: pointerDate,
              onHover: onHover,
              disabled: disabled,
              onSelectDate: _this2.selectDate,
              dateText: pointerDate.date(),
              dateCellRender: dateCellRender
            });
          }
        });
        html.push( /*#__PURE__*/React.createElement("tr", {
          key: "".concat(pointerDate.date()).concat(pointerDate.month())
        }, tdArr)); // 为了完整显示当月日期，需要使用 6 行日期

        if (html.length > 5) {
          break;
        } // if (
        //     pointerDate.day() === 0
        //     && pointerDate.add(1, 'day').month() === nextMonth.month()
        // ) {
        //     break;
        // }

      }

      return html.slice(0, 6);
    }
  }, {
    key: "render",
    value: function render() {
      var startDate = this.state.startDate;
      var _this$props2 = this.props,
          show = _this$props2.show,
          type = _this$props2.type;
      var clx = type === 'week' ? 'roo-datepicker-days roo-datepicker-week' : 'roo-datepicker-days';
      return /*#__PURE__*/React.createElement("div", {
        className: clx,
        style: {
          display: "".concat(show ? 'block' : 'none')
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-datepicker-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-pre"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "double-left",
        size: "18px",
        onClick: this.preYear
      }), /*#__PURE__*/React.createElement(Icon, {
        name: "chevron-left",
        size: "18px",
        onClick: this.preMonth
      })), /*#__PURE__*/React.createElement("div", {
        className: "action-select"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: this.showYear
      }, startDate.year()), /*#__PURE__*/React.createElement("a", {
        onClick: this.showMonth
      }, CONST.MONTH[startDate.month()])), /*#__PURE__*/React.createElement("div", {
        className: "action-next"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "chevron-right",
        size: "18px",
        onClick: this.nextMonth
      }), /*#__PURE__*/React.createElement(Icon, {
        name: "double-right",
        size: "18px",
        onClick: this.nextYear
      })))), /*#__PURE__*/React.createElement("div", {
        className: "roo-datepicker-body"
      }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, CONST.DAYS.map(function (day) {
        return /*#__PURE__*/React.createElement("th", {
          key: day
        }, day);
      }))), /*#__PURE__*/React.createElement("tbody", null, this.renderDatePanel()))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (!nextProps.startDate) {
        return {};
      }

      if (nextProps.startDate.valueOf() !== state.startDate.valueOf() || nextProps.selectDate.valueOf() !== state.selectDate.valueOf()) {
        return {
          startDate: nextProps.startDate,
          selectDate: nextProps.selectDate
        };
      }

      return {};
    }
  }]);

  return DatePanel;
}(React.Component);

DatePanel.defaultProps = {
  show: true,
  startDate: dayjs(),
  selectDate: [dayjs()],
  type: 'date',
  onHover: function onHover() {},
  disabledDate: function disabledDate() {
    return false;
  },
  onSelectDate: function onSelectDate() {},
  onShowPanel: function onShowPanel() {},
  handleChangeDate: function handleChangeDate() {}
};
DatePanel.propTypes = {
  show: PropTypes.bool,
  startDate: PropTypes.object,
  selectDate: PropTypes.array,
  type: PropTypes.string,
  onHover: PropTypes.func,
  onSelectDate: PropTypes.func,
  disabledDate: PropTypes.func,
  onShowPanel: PropTypes.func,
  handleChangeDate: PropTypes.func
};
polyfill(DatePanel);
export default DatePanel;